import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {
        // 园所收货地址设置为默认
        getSchoolAddressList(params) {
            this.loading = true;
            $http.get("api/School/School_DefaultSchoolConsignee", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: "设置默认地址成功",
                        type: 'success'
                    });
                });
            });
        },
        //修改收货地址
        addSchoolConsigneeList() {

            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;

            $http.post("api/School/School_SaveSchoolConsignee", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                    });
                    //this.getSchoolConsigneeList(this.SchoolId)
                    this.$emit('address', this.form)
                    this.addAddressVisible = false
                    this.form = this.initConsignee();
                    this.$refs.area.clearResultValue()

                });
            });

        },
        // 获取收货地址
        // getSchoolConsigneeList(id) {
        //     let params = {
        //         Sid: this.$store.state.sysSid,
        //         Session: this.$store.state.sysSession,
        //         schoolId: id
        //     };
        //     //this.addressObject = {}

        //     this.loading = true;
        //     $http.get("api/School/GetSchoolConsigneeList", params).then(res => {
        //         let {
        //             Data,
        //             Cnt
        //         } = res.data;
        //         this.loading = false;
        //         util.doResult(this, res, () => {
        //             this.AddressList = Data;
        //             for (let i = 0; i < this.AddressList.length; i++) {
        //                 //IsDefault==1为默认地址
        //                 if (this.AddressList[i].IsDefault == 1) {

        //                     this.addressObject = this.AddressList[i]
        //                     // shezhi
        //                     this.form.Consignee = this.addressObject.Consignee
        //                     this.form.ConsigneeTel = this.addressObject.ConsigneeTel
        //                     this.form.ConsigneeAdress = this.addressObject.ConsigneeAdress
        //                     this.form.ConsigneeProvince = this.addressObject.ConsigneeProvince;
        //                     this.form.ConsigneeCity = this.addressObject.ConsigneeCity;
        //                     this.form.ConsigneeArea = this.addressObject.ConsigneeArea;
        //                     this.Address = []
        //                     this.Address.Provinces_Id = this.form.ConsigneeProvince;
        //                     this.Address.City_Id = this.form.ConsigneeCity;
        //                     this.Address.Area_Id = this.form.ConsigneeArea;
        //                     this.$emit('address', this.AddressList[i])
        //                 }
        //             }
        //         });
        //     });
        // },
    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/AddressDialog/services.js